import React, { FC } from 'react';
import {
  TypeCtaWithTrailingTextFields,
  TypeImage,
  TypeLink_internalFields,
  TypeSideBySideCTAFields,
} from '@/core/generated-types';
import { Image } from '@/components/ui/Image';
import classNames from 'classnames';
import { RichText } from '../RichText';
import { Document } from '@contentful/rich-text-types';
import { HeaderText } from '@/components/ui';
import { HeaderSize } from '@/components/ui/HeaderText';
import { UniversalCta } from '../UniversalCta';
import { CONTENT_TYPE_LINK, getContentType } from '@/core/constants';
import { CTAWithTrailingText } from '../CTAWithTrailingText';
import { Entry } from 'contentful';

const SideBySideCTA: FC<TypeSideBySideCTAFields> = ({
  title,
  subtitle,
  media,
  cta,
  mediaLeft,
  titleAsH1 = false,
  backgroundColor,
}) => {
  return (
    <div
      className={classNames(
        `bg-${backgroundColor?.fields?.color} flex flex-col overflow-hidden md:max-h-[550px] md:flex-row`,
        {
          'md:flex-row-reverse': mediaLeft,
        },
      )}
    >
      <div className="w-full flex-none md:w-1/2">
        <Image
          alt={media?.fields?.altText}
          className="h-full w-full object-cover"
          imageData={media as TypeImage}
        />
      </div>
      <div
        className={classNames(
          'flex w-full flex-none items-center px-8 py-8 text-center md:w-1/2 md:px-16 md:py-16 md:text-left',
          {
            'justify-end': mediaLeft,
          },
        )}
      >
        <div className="max-w-[600px]">
          {titleAsH1 ? (
            <HeaderText size={HeaderSize.H1} text={title} />
          ) : (
            <div
              className="text-[32px] font-bold leading-[40px] md:text-[42px] md:leading-[56px]"
              data-testid="title"
            >
              {title}
            </div>
          )}

          {subtitle && (
            <div
              className="mt-4 text-base leading-[27px] md:text-[20px]"
              data-testid="subtitle"
            >
              <RichText content={subtitle as Document} />
            </div>
          )}
          {cta && (
            <div data-testid="cta">
              {getContentType(cta) ===
              CONTENT_TYPE_LINK.CTA_WITH_TRAILING_TEXT ? (
                <CTAWithTrailingText
                  {...(cta?.fields as TypeCtaWithTrailingTextFields)}
                  className="mt-8 inline-flex"
                />
              ) : (
                <UniversalCta
                  key={cta.sys.id}
                  className="mt-8 inline-flex"
                  link={cta as Entry<TypeLink_internalFields>}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SideBySideCTA);
